module.exports = __webpack_public_path__ + "img/11.44124334.png";